import React from "react";

import * as S from "./styles";
import { datetimeHelper } from "@helpers/datetime";
import { AiOutlineCalendar, AiOutlineEye } from "react-icons/ai";

import cpfIcon from "@assets/cpfIcon.svg";
import { MdReplay } from "react-icons/md";
import { ImportHistory } from "@domain/models/ImportHistory";

type Props = {
  data: ImportHistory;
  onView: () => void;
  onUndo: () => void;
};

export default function HistoryListItem({ data, onView, onUndo }: Props) {
  return (
    <S.Container>
      <div>
        <h4>{data.undo ? data.undo.userName : data.userName}</h4>
      </div>
      <div>
        <S.Status undo={data.undo ? true : false}>{data.undo ? "Desfeita" : "Concluída"}</S.Status>
      </div>
      <div>
        <AiOutlineCalendar color="var(--grey2)" />
        <h4>{datetimeHelper.getDate(data.createdAt)}</h4>
      </div>
      <div>
        <img src={cpfIcon} alt="cpf" />
        <h4>{data.importedClients}</h4>
      </div>
      <div>
        <img src={cpfIcon} alt="cpf" />
        <h4>{data.notImportedClients}</h4>
      </div>
      <div>
        <img src={cpfIcon} alt="cpf" />
        <h4>{data.importedClients + data.notImportedClients}</h4>
      </div>
      <div>
        <AiOutlineEye
          onClick={onView}
          cursor="pointer"
          size={18}
          color="#808B9F"
          fill="#808B9F"
          style={{ marginLeft: 10 }}
        />
        {!data.undo && (
          <MdReplay
            onClick={onUndo}
            cursor="pointer"
            size={18}
            color="#808B9F"
            fill="#808B9F"
            style={{ marginLeft: 10 }}
          />
        )}
      </div>
    </S.Container>
  );
}
